import React, { useEffect } from "react";
import styles from "./Modal.module.css";
import CloseIcon from "../../images/CloseIcon.png";

const Modal = ({ isOpen, onClose, children, widthModalContent }) => {
  // Prevent background scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add(styles.noScroll);
    } else {
      document.body.classList.remove(styles.noScroll);
    }
    
    // Cleanup function to remove the class when component unmounts
    return () => {
      document.body.classList.remove(styles.noScroll);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <main
        className={`${styles.modalContent} ${widthModalContent}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
        <img
          onClick={onClose}
          className={styles.closeIcon}
          src={CloseIcon}
          alt="Close"
          aria-hidden="true"
        />
      </main>
    </div>
  );
};

export default Modal;
